//#region src/values/Trigger.ts
var e = {
	HOVER: "hover",
	CLICK: "click",
	FOCUS: "focus"
};
//#endregion
export { e as TRIGGER };

//# sourceMappingURL=Trigger.js.map